import { render, staticRenderFns } from "./CtcAssistantHero.vue?vue&type=template&id=48828a77&scoped=true&"
import script from "./CtcAssistantHero.vue?vue&type=script&lang=js&"
export * from "./CtcAssistantHero.vue?vue&type=script&lang=js&"
import style0 from "./CtcAssistantHero.vue?vue&type=style&index=0&id=48828a77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48828a77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
